import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
export function HeroSection() {
  return <section className="bg-forest text-cream py-16 md:py-24 px-6" data-id="element-61">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-62">
        <FadeIn data-id="element-63">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-64">
            Rescate Renal: El plan de 14 días para limpiar tus riñones y
            recuperar la libertad de tu salud.
          </h1>
          <h2 className="text-xl md:text-2xl font-sans text-cream/90 mb-10 leading-relaxed" data-id="element-65">
            Detén el miedo a la diálisis, reduce la toxicidad en tu sangre y
            vuelve a sentirte ligero con el protocolo de nutrición, hidratación
            y recetas más completo y humano del mercado.
          </h2>
          <CTAButton className="md:mx-0" onClick={() => {
          document.getElementById('offer-section')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-66">
            ¡SÍ, QUIERO RESCATAR MIS RIÑONES HOY MISMO!
          </CTAButton>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-67">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-cream/20" data-id="element-68">
            <img src="https://cdn.magicpatterns.com/uploads/sb1go4bugdizBunDGFRUf5/Digital_product_bundle_for_kidney_health.png" alt="Paquete digital del Protocolo de Rescate Renal con recetas y guía de análisis" className="w-full h-auto object-cover" data-id="element-69" />
          </div>
        </FadeIn>
      </div>
    </section>;
}